import React, { Component } from "react";

import api from "services/api";
import swal from "sweetalert";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Professionals/Customers/components";

class Create extends Component {
  state = {
    data: {
      customer: null,
      professinal: null,
      duration_days: 1,
    },

    saving: false,

    errors: {},

    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Profissionais EAD", to: "/professionals" },
      { name: "Clientes EAD", to: "/professionals/customers" },
      { name: "Atribuir Cliente", to: "" },
    ],
  };

  handleChange = (data) => {
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      customer: {
        required: true,
      },

      professional: {
        required: true,
      },

      duration_days: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    try {
      this.setState({ saving: true });
      await api.post("relationship/v2/customers/presentials", {
        customer_presential: {
          customer_id: data.customer.value,
          professional_id: data.professional.value,
          duration_days: data.duration_days * 7,
        },
      });

      this.setState({
        data: {
          customer: null,
          professinal: null,
          duration_days: 0,
        },
      });
      swal(
        "Cliente Atribuido",
        "O cliente foi atribuído ao profissional EAD com sucesso.",
        "success"
      );
      this.props.history.push('/professionals/customers')
    } catch (err) {

      if (err.response.data && err.response.data.error) {
        swal(
          "Algo deu errado",
          err.response.data.error.message,
          "error"
        );
      } else {
        swal(
          "Algo deu errado",
          "Não foi possível atualizar os pontos do habitante.",
          "error"
        );
      }


    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { data, breadcrumbs, errors, saving } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={saving}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

export default Create;
